import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { fileUrl } from "../lib/api";
import { Download, FileText, Image as ImageIcon, Video, Box, Folder, ArrowUpRight } from "lucide-react";

const TYPE_ICONS = {
  powerpoint: FileText, word: FileText, excel: FileText,
  images: ImageIcon, icons: Box, "3d-icons": Box,
  animation: Video, video: Video, other: Folder,
};
const TYPE_COLORS = {
  powerpoint: "#F97316", word: "#3B82F6", excel: "#22C55E",
  images: "#A855F7", icons: "#EAB308", "3d-icons": "#06B6D4",
  animation: "#EF4444", video: "#F59E0B", stickers: "#EC4899",
  cv: "#14B8A6", school: "#10B981", other: "#64748B",
};

function isImage(ext) {
  return ["png", "jpg", "jpeg", "webp", "gif", "svg"].includes((ext || "").toLowerCase());
}

export default function AssetCard({ item, rank }) {
  const { t } = useLang();
  const Icon = TYPE_ICONS[item.category] || Folder;
  const color = TYPE_COLORS[item.category] || "#64748B";
  const showImg = isImage(item.extension);

  return (
    <Link
      to={`/asset/${item.id}`}
      className="group card card-hover flex flex-col overflow-hidden"
      data-testid={`asset-card-${item.id}`}
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden" style={{ backgroundColor: "hsl(var(--surface-2))" }}>
        {showImg ? (
          <img
            src={fileUrl(item.url)}
            alt={item.title}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center" style={{ backgroundColor: `${color}22` }}>
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl text-white shadow-lg" style={{ backgroundColor: color }}>
              <Icon className="h-8 w-8" />
            </div>
          </div>
        )}
        {rank != null && (
          <span className="absolute start-3 top-3 font-display text-3xl text-white drop-shadow-md">
            {String(rank).padStart(2, "0")}
          </span>
        )}
        <span
          className="absolute end-3 top-3 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.18em]"
          style={{ backgroundColor: "hsl(var(--bg))", color: "hsl(var(--ink))" }}
        >
          {item.extension || item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display line-clamp-1 text-lg text-ink">{item.title}</h3>
          <ArrowUpRight className="h-4 w-4 shrink-0 text-muted-fg transition-all group-hover:rotate-45 group-hover:text-accent" />
        </div>
        <p className="mt-1 line-clamp-2 text-xs text-muted-fg">{item.description || item.original_name}</p>
        <div className="mt-3 flex items-center justify-between text-[11px] uppercase tracking-[0.14em] text-muted-fg">
          <span>{t("by")} <span className="text-ink">{item.owner_name}</span></span>
          <span className="inline-flex items-center gap-1">
            <Download className="h-3 w-3" />
            {item.download_count}
          </span>
        </div>
      </div>
    </Link>
  );
}
